import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: `${config.Url}${config.devAssetsFolder}/img/ball-notfound-fit.png`,
    loading: `${config.Url}${config.devAssetsFolder}/img/ball-loading-fit.png`,
    attempt: 2
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/lazyLoad.js